import { Alert, Flex } from "antd";
import { useState } from "react";
import Filters from "../../components/Filters";
import MainMetrics from "../../components/MainMetrics";
import TablesWrapper from "../../components/TablesWrapper";
import { useAuth } from "../../context/AuthContext";
import useAttentionV2 from "../../hooks/useAttentionV2";
import useCollections from "../../hooks/useCollections";
import {
  PEAK_HOURS_METRICS,
  PEAK_HOURS_TABLE_COLUMNS,
} from "../../utils/constants";
import { filtrosDaAtencao, temDadoDeZona } from "../flow-detections/fluxoDaV2";
import { periodoSemiaberto } from "../general/homeV2Helpers";
import { filtrosDaV2 } from "../revenue/kpisDaV2";
import ChartsWrapper from "./ChartsWrapper";
import { cartoesDoPico, indisponiveisDoPico, tabelasDoPico } from "./picoDaV2";

export default function PeakHoursRefact() {
  const { user } = useAuth();
  const branchId = user?.active_branch_id ?? null;
  const { modoOuran, legacyIdDaColecao } = useCollections();
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [selectedPeriod, setSelectedPeriod] = useState([9, 19]);
  const [selectedZones, setSelectedZones] = useState(["all"]);
  const [selectedCollections, setSelectedCollections] = useState(["all"]);

  const periodo = periodoSemiaberto(selectedDateRange);
  const filtrosDaTela = filtrosDaAtencao(
    filtrosDaV2({
      zonas: selectedZones,
      colecoes: selectedCollections,
      modoOuran,
      legacyIdDaColecao,
    })
  );
  const atencao = useAttentionV2({
    branchId,
    start: periodo.start,
    end: periodo.end,
    groupBy: "hour",
    filtros: filtrosDaTela,
  });
  const cartoes = atencao.data
    ? cartoesDoPico({ atencao: atencao.data })
    : undefined;
  const tabelas = atencao.data ? tabelasDoPico(atencao.data) : undefined;
  const unavailableKpis = atencao.isError
    ? PEAK_HOURS_METRICS.map((m) => m.key)
    : indisponiveisDoPico(cartoes);
  const carregando = atencao.isLoading;

  return (
    <Flex
      style={{ width: "100%", margin: "0 auto" }}
      justify="center"
      align="center"
      vertical
      gap={"50px"}>
      <Filters
        page="peak_hours"
        filters={["data", "zonas", "colecoes"]}
        isMainDataLoading={carregando}
        dateRange={true}
        selectedDateRange={selectedDateRange}
        setSelectedDateRange={setSelectedDateRange}
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
        selectedZones={selectedZones}
        setSelectedZones={setSelectedZones}
        selectedCollections={selectedCollections}
        setSelectedCollections={setSelectedCollections}
      />
      <MainMetrics
        data={cartoes}
        isLoading={carregando}
        kpis={PEAK_HOURS_METRICS}
        unavailableKeys={unavailableKpis}
      />
      {!carregando && (atencao.isError || !temDadoDeZona(atencao.data)) && (
        <Alert
          style={{ width: "85%", maxWidth: "100%" }}
          type="info"
          showIcon
          message="Sem dados de zona no período selecionado."
          description="Os horários de pico são calculados a partir da detecção nas zonas. Se alguma zona foi cadastrada há pouco, o dado passa a aparecer a partir da próxima rodada do processamento."
        />
      )}
      <ChartsWrapper
        branchId={branchId}
        periodo={periodo}
        filtrosDaAtencao={filtrosDaTela}
      />
      <TablesWrapper
        data={tabelas}
        isLoading={carregando}
        columns={PEAK_HOURS_TABLE_COLUMNS}
        tablesPerRow={1}
        tablesName={[
          "Horários com fluxo acima da média",
          "Horários com fluxo abaixo da média",
        ]}
      />
    </Flex>
  );
}
